import { patchRecord } from '@/entities/shared/record/patch-record';
import type { ShoppingItem } from '../schemas/shopping-item';
import { shoppingItemSchema } from '../schemas/shopping-item';

/** Change some fields; null removes one. */
export async function patchShoppingItem(
  id: string,
  patch: { readonly [K in keyof ShoppingItem]?: ShoppingItem[K] | null },
): Promise<void> {
  await patchRecord('shopping', shoppingItemSchema, id, patch);
}
